module.exports = __webpack_public_path__ + "assets/img/thumb-Cluey-Learning-2-Landing-Page-+-Website.827a6c32.jpg";